import type { ReactNode } from 'react';

export interface DialogMediaFooterProps {
  redirectButton?: ReactNode;
  closeButton?: ReactNode;
  actionButton?: ReactNode;
}

const DialogMediaFooter = ({ redirectButton, closeButton, actionButton }: DialogMediaFooterProps) => {
  return (
    <div className={`flex items-center ${redirectButton ? 'justify-between' : 'justify-end'}`}>
      {redirectButton}
      <div className='flex gap-2'>
        {closeButton}
        {actionButton}
      </div>
    </div>
  );
};

export default DialogMediaFooter;
